import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "raskDecimal" })
export class DecimalPipe implements PipeTransform {
    transform(nr: string | number, decimals?: number): string {
        return nr != null ? `${parseFloat(nr.toString()).toFixed(decimals ?? 0)}` : "-";
    }
}
